// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── page wrapper ────────────────────────────────────────── */
.op-page {
  height: 100vh;
  width: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 16px;
  gap: 16px;
  box-sizing: border-box;
  font-family: "Inter", "Segoe UI", sans-serif;
}

@media (min-width: 1024px) {
  .op-page {
    padding: 20px;
    gap: 20px;
  }
}

/* ── header card (standalone) ────────────────────────────── */
.op-header-card {
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  flex-shrink: 0;
}

/* ── old full card — neutralised ─────────────────────────── */
.op-card {
  display: contents;
}

/* ── header ──────────────────────────────────────────────── */
.op-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  flex-shrink: 0;
}

@media (min-width: 1024px) {
  .op-header {
    padding: 12px 32px;
  }
}

.op-header-left-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

.op-logo {
  height: 28px;
  width: auto;
  object-fit: contain;
}

@media (min-width: 1024px) {
  .op-logo {
    height: 32px;
  }
}

.op-step-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #bfdbfe;
  color: #2a71ff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
  padding: 4px 12px;
  border-radius: 9999px;
  background-color: #eff6ff;
}

/* ── back button ─────────────────────────────────────────── */
.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  background-color: #ffffff;
  color: #64748b;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
  flex-shrink: 0;
}

.back-btn:hover {
  background-color: #f8fafc;
  color: #0f172a;
}

.back-icon {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* ── body ────────────────────────────────────────────────── */
.op-body {
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 transparent;
}

.op-body::-webkit-scrollbar { width: 4px; }
.op-body::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 4px; }

/* ── section panel — flat, no card chrome ────────────────── */
.op-section {
  padding: 0;
}

/* ── title/breadcrumb row — flat ─────────────────────────── */
.op-setup-section {
  display: flex;
  flex-direction: column;
}

/* ── opening cash — flat ─────────────────────────────────── */
.op-cash-section {
  padding: 0;
}

.op-section-tag {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.18em;
  color: #2a71ff;
  margin: 0 0 6px 0;
  text-transform: uppercase;
}

/* ── setup section header ────────────────────────────────── */
.op-setup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.op-title {
  font-size: 1.5rem;
  font-weight: 900;
  color: #020617;
  margin: 4px 0 0 0;
  letter-spacing: -0.025em;
}

@media (min-width: 1024px) {
  .op-title {
    font-size: 2rem;
  }
}

/* ── breadcrumbs ─────────────────────────────────────────── */
.op-breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.op-crumb {
  font-size: 13px;
  font-weight: 700;
  padding: 6px 16px;
  border-radius: 9999px;
  border: 1px solid;
  /* default: blue (location) */
  color: #2563eb;
  background: rgba(239, 246, 255, 0.5);
  border-color: #bfdbfe;
}

/* second crumb: green (terminal) */
.op-crumb:nth-child(2) {
  color: #059669;
  background: rgba(236, 253, 245, 0.5);
  border-color: #a7f3d0;
}

/* third / purple crumb (channel / retailType) */
.op-crumb.purple,
.op-crumb:nth-child(4) {
  color: #7c3aed;
  background: rgba(245, 243, 255, 0.5);
  border-color: #ddd6fe;
}

.op-crumb.yellow,
.op-crumb:nth-child(3) {
  color: #92400e;
  background: rgba(254, 243, 199, 0.5);
  border-color: #fde68a;
}

/* ── checks section internals ────────────────────────────── */
.op-checks-header {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.op-clear-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #94a3b8;
  padding: 4px 0;
  text-transform: uppercase;
  transition: color 0.15s;
}

.op-clear-btn:hover {
  color: #2a71ff;
}

/* ── check cards grid ────────────────────────────────────── */
.op-checks-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

/* ── single check card ───────────────────────────────────── */
.op-check-card {
  border-radius: 22px;
  padding: 18px 18px 16px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 0;
  transition:
    box-shadow 0.18s ease,
    border-color 0.18s ease;
}

.op-check-card:hover {
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.07);
}

.op-check-card.ready {
  border-color: #d1fae5;
  background: #ffffff;
}

.op-check-card.attention {
  border-color: #fde68a;
  background: #ffffff;
}

.op-check-card.failed {
  border-color: #fca5a5;
  background: #ffffff;
}

/* ── card top row: icon + status badge ── */
.op-check-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.op-check-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.op-check-icon.ready {
  background: #ecfdf5;
  color: #059669;
}

.op-check-icon.attention {
  background: #fffbeb;
  color: #d97706;
}

.op-check-icon.failed {
  background: #fef2f2;
  color: #ef4444;
}

.op-check-status {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 9999px;
}

.op-check-status.ready {
  color: #047857;
  background: #ecfdf5;
}

.op-check-status.attention {
  color: #b45309;
  background: #fffbeb;
}

.op-check-status.failed {
  color: #b91c1c;
  background: #fef2f2;
}

/* ── card text ── */
.op-check-name {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 3px 0;
  letter-spacing: -0.01em;
}

.op-check-desc {
  font-size: 12px;
  color: #94a3b8;
  margin: 0;
  line-height: 1.4;
}

/* ── status info pill ── */
.op-check-info {
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 10px;
  padding: 9px 12px;
  font-size: 11.5px;
  font-weight: 500;
  color: #64748b;
  margin: 12px 0 0 0;
  line-height: 1.45;
  flex: 1;
  min-height: 38px;
}

/* ── single action button at bottom ── */
.op-check-card-actions {
  margin-top: 14px;
}

/* "Check" state — outlined neutral */
.op-check-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 40px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  font-size: 12.5px;
  font-weight: 700;
  color: #374151;
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s,
    color 0.15s;
}

.op-check-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.op-check-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Container for the retry and mark as ready buttons when checked */
.op-checked-actions {
  display: flex;
  gap: 8px;
  width: 100%;
}

/* Retry button — styled like .op-check-btn but square */
.op-retry-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  color: #374151;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    border-color 0.15s,
    background 0.15s,
    color 0.15s;
}

.op-retry-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.op-retry-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* "Mark ready" state — solid blue, same size */
.op-mark-ready-btn {
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 40px;
  background: #2a71ff;
  border: 1.5px solid transparent;
  border-radius: 12px;
  font-size: 12.5px;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
  transition: background 0.15s;
}

.op-mark-ready-btn:hover:not(:disabled) {
  background: #155eef;
}

.op-mark-ready-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}



/* "Confirmed" state — green static badge (no pointer) */
.op-check-confirmed {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 40px;
  background: #f0fdf4;
  border: 1.5px solid #bbf7d0;
  border-radius: 12px;
  font-size: 12.5px;
  font-weight: 700;
  color: #15803d;
  cursor: default;
}

/* ── opening cash section ────────────────────────────────── */
.op-cash-desc {
  font-size: 13px;
  color: #64748b;
  margin: 6px 0 20px 0;
}

.op-cash-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.op-amount-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.op-rupee {
  position: absolute;
  left: 14px;
  font-size: 14px;
  font-weight: 900;
  color: #94a3b8;
  pointer-events: none;
  line-height: 1;
}

.op-amount-input {
  height: 48px;
  width: 240px;
  padding-left: 36px;
  padding-right: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 900;
  color: #020617;
  background: #ffffff;
  outline: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}

.op-amount-input:focus {
  border-color: #2a71ff;
  box-shadow: 0 0 0 3px rgba(42, 113, 255, 0.1);
}

.op-amount-input::placeholder {
  color: #cbd5e1;
  font-weight: 400;
}

.op-amount-input::-webkit-outer-spin-button,
.op-amount-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* ── action buttons ──────────────────────────────────────── */
.op-cash-btns {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
  align-self: flex-end;
}

.op-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  padding: 0 32px;
  border: 1px solid;
  border-radius: 18px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 0.15s,
    box-shadow 0.15s;
  white-space: nowrap;
}

.op-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.op-btn.manager {
  background: #4a72b5;
  border-color: rgba(74, 114, 181, 0.3);
  color: #fff;
  box-shadow: 0 4px 14px rgba(74, 114, 181, 0.2);
}

.op-btn.manager:hover:not(:disabled) {
  background: #3a62a5;
}

.op-btn.pos-user {
  background: #0f172a;
  border-color: rgba(15, 23, 42, 0.2);
  color: #fff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.15);
}

.op-btn.pos-user:hover:not(:disabled) {
  background: #1e293b;
}

/* ── bottom actions ──────────────────────────────────────── */
.op-bottom-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 4px;
  flex-wrap: wrap;
}

.op-action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 18px;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  border: 1.5px solid;
}

.op-action-btn.location {
  background: #f0f5ff;
  border-color: #c5d4f0;
  color: #4a72b5;
}

.op-action-btn.location:hover {
  background: #e3ecff;
}

.op-action-btn.logout {
  background: #fff5f5;
  border-color: #fecaca;
  color: #dc2626;
}

.op-action-btn.logout:hover {
  background: #fee2e2;
}

/* ── responsive ──────────────────────────────────────────── */
@media (max-width: 640px) {
  .op-checks-grid {
    grid-template-columns: 1fr;
  }

  .op-cash-row {
    flex-direction: column;
    align-items: stretch;
  }

  .op-amount-input {
    width: 100%;
  }

  .op-cash-btns {
    justify-content: stretch;
  }

  .op-btn {
    flex: 1;
  }
}

/* duplicate op-card/op-body blocks removed — see top of file */

/* ── global overflow fix ─────────────────────────────────── */
html,
body,
#root {
  overflow-x: hidden;
  max-width: 100%;
}

/* ── page wrapper ────────────────────────────────────────── */
.system-health__page {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: radial-gradient(circle at top left, rgba(42, 113, 255, 0.14), transparent 24%),
    linear-gradient(180deg, #f6f9ff 0%, #eef4ff 45%, #f8fafc 100%);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  font-family: "Inter", "Segoe UI", sans-serif;
  color: #020617;
}

@media (min-width: 1024px) {
  .system-health__page {
    padding: 20px;
  }
}

/* ── main card ───────────────────────────────────────────── */
.system-health__card {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 34px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  width: 100%;
  max-width: 1680px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 24px 90px rgba(15, 23, 42, 0.12);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-sizing: border-box;
}

/* ── header ──────────────────────────────────────────────── */
.system-health__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  flex-shrink: 0;
  min-width: 0;
}

@media (min-width: 1024px) {
  .system-health__header {
    padding: 16px 32px;
  }
}

.system-health__header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
}

.system-health__logo {
  height: 40px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
}

@media (min-width: 1024px) {
  .system-health__logo {
    height: 44px;
  }
}

.system-health__step-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #bfdbfe;
  color: #2a71ff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
  padding: 4px 12px;
  border-radius: 9999px;
  background-color: #eff6ff;
  text-transform: uppercase;
  white-space: nowrap;
  flex-shrink: 0;
}

/* ── back button ─────────────────────────────────────────── */
.system-health__back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  background-color: #ffffff;
  color: #64748b;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
  flex-shrink: 0;
}

.system-health__back-btn:hover {
  background-color: #f8fafc;
  color: #0f172a;
}

.system-health__back-icon {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* ── body ────────────────────────────────────────────────── */
.system-health__body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  /* custom scrollbar */
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.system-health__body::-webkit-scrollbar {
  width: 6px;
}
.system-health__body::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 9999px;
}
.system-health__body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 9999px;
}
.system-health__body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (min-width: 1024px) {
  .system-health__body {
    padding: 40px;
  }
}

/* ── inner content max-width wrapper ─────────────────────── */
.system-health__body > * {
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

/* ── section panel ───────────────────────────────────────── */
.system-health__section {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 28px;
  padding: 20px 24px;
  box-sizing: border-box;
  min-width: 0;
}

@media (min-width: 1024px) {
  .system-health__section {
    padding: 24px 32px;
  }
}

.system-health__section-tag {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.18em;
  color: #2a71ff;
  margin: 0 0 6px 0;
  text-transform: uppercase;
}

/* ── setup section header ────────────────────────────────── */
.system-health__setup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;
}

@media (max-width: 640px) {
  .system-health__setup-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

.system-health__title {
  font-size: 1.5rem;
  font-weight: 900;
  color: #020617;
  margin: 4px 0 0 0;
  letter-spacing: -0.025em;
}

@media (min-width: 1024px) {
  .system-health__title {
    font-size: 2rem;
  }
}

/* ── breadcrumbs ─────────────────────────────────────────── */
.system-health__breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.system-health__crumb {
  font-size: 13px;
  font-weight: 700;
  padding: 6px 16px;
  border-radius: 9999px;
  border: 1px solid;
  color: #2563eb;
  background: rgba(239, 246, 255, 0.5);
  border-color: #bfdbfe;
  white-space: nowrap;
}

.system-health__crumb:nth-child(2) {
  color: #059669;
  background: rgba(236, 253, 245, 0.5);
  border-color: #a7f3d0;
}

.system-health__crumb--purple,
.system-health__crumb:nth-child(3) {
  color: #7c3aed;
  background: rgba(245, 243, 255, 0.5);
  border-color: #ddd6fe;
}

/* ── check cards grid ────────────────────────────────────── */
.system-health__checks-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  min-width: 0;
}

@media (max-width: 1023px) {
  .system-health__checks-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .system-health__checks-grid {
    grid-template-columns: 1fr;
  }
}

/* ── single check card ───────────────────────────────────── */
.system-health__check-card {
  border-radius: 26px;
  padding: 20px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition:
    box-shadow 0.18s ease,
    border-color 0.18s ease;
  box-sizing: border-box;
  min-width: 0;
}

.system-health__check-card:hover {
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.07);
}

.system-health__check-card--ready {
  border-color: #d1fae5;
  background: #ffffff;
}

.system-health__check-card--attention {
  border-color: #fde68a;
  background: #ffffff;
}

/* ── card top row: icon + status badge ── */
.system-health__check-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 0;
}

.system-health__check-icon {
  width: 40px;
  height: 40px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.system-health__check-icon--ready {
  background: #ecfdf5;
  color: #059669;
}

.system-health__check-icon--attention {
  background: #fffbeb;
  color: #d97706;
}

.system-health__check-status {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  padding: 4px 12px;
  border-radius: 9999px;
}

.system-health__check-status--ready {
  color: #047857;
  background: #ecfdf5;
}

.system-health__check-status--attention {
  color: #b45309;
  background: #fffbeb;
}

/* ── card text ── */
.system-health__check-name {
  font-size: 18px;
  font-weight: 900;
  color: #0f172a;
  margin: 20px 0 4px 0;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.system-health__check-desc {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
  line-height: 1.4;
}

/* ── status info pill ── */
.system-health__check-info {
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 16px;
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  margin: 16px 0 0 0;
  line-height: 1.45;
}

/* ── single action button at bottom ── */
.system-health__check-actions {
  margin-top: 20px;
}

/* "Check" state — outlined neutral */
.system-health__check-btn {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 700;
  color: #374151;
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s,
    color 0.15s;
}

.system-health__check-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.system-health__check-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* "Mark ready" state — solid blue */
.system-health__mark-ready-btn {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  background: #2a71ff;
  border: 1.5px solid transparent;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
  transition: background 0.15s;
}

.system-health__mark-ready-btn:hover {
  background: #155eef;
}

/* "Confirmed" state — green static badge */
.system-health__check-confirmed {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  background: #f0fdf4;
  border: 1.5px solid #bbf7d0;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 700;
  color: #15803d;
  cursor: default;
}

/* ── opening cash section ────────────────────────────────── */
.system-health__cash-desc {
  font-size: 13px;
  color: #64748b;
  margin: 6px 0 20px 0;
  line-height: 1.5;
}

.system-health__cash-row {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

@media (min-width: 1024px) {
  .system-health__cash-row {
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }
}

.system-health__cash-left {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  max-width: 400px;
  min-width: 0;
}

.system-health__amount-wrap {
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.system-health__rupee-symbol {
  position: absolute;
  left: 14px;
  font-size: 14px;
  font-weight: 900;
  color: #94a3b8;
  pointer-events: none;
  line-height: 1;
}

.system-health__amount-input {
  height: 48px;
  width: 100%;
  max-width: 240px;
  padding-left: 36px;
  padding-right: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 900;
  color: #020617;
  background: #ffffff;
  outline: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
  box-sizing: border-box;
}

.system-health__amount-input:focus {
  border-color: #2a71ff;
  box-shadow: 0 0 0 3px rgba(42, 113, 255, 0.1);
}

.system-health__amount-input::placeholder {
  color: #cbd5e1;
  font-weight: 400;
}

.system-health__amount-input::-webkit-outer-spin-button,
.system-health__amount-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* ── action buttons ──────────────────────────────────────── */
.system-health__cash-btns {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.system-health__cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  padding: 0 32px;
  border: 1px solid;
  border-radius: 18px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 0.15s,
    box-shadow 0.15s;
  white-space: nowrap;
}

.system-health__cta-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.system-health__cta-btn--manager {
  background: #4a72b5;
  border-color: rgba(74, 114, 181, 0.3);
  color: #fff;
  box-shadow: 0 4px 14px rgba(74, 114, 181, 0.2);
}

.system-health__cta-btn--manager:hover:not(:disabled) {
  background: #3a62a5;
}

.system-health__cta-btn--pos-user {
  background: #0f172a;
  border-color: rgba(15, 23, 42, 0.2);
  color: #fff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.15);
}

.system-health__cta-btn--pos-user:hover:not(:disabled) {
  background: #1e293b;
}

/* ── responsive cash row ─────────────────────────────────── */
@media (max-width: 640px) {
  .system-health__cash-row {
    flex-direction: column;
    align-items: stretch;
  }

  .system-health__cash-left {
    max-width: 100%;
  }

  .system-health__amount-input {
    max-width: 100%;
  }

  .system-health__cash-btns {
    justify-content: stretch;
  }

  .system-health__cta-btn {
    flex: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/components/Opening/indexV2.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;AACF;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,iBAAiB;AACnB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf;;mBAEiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,8BAA8B,UAAU,EAAE;AAC1C,oCAAoC,mBAAmB,EAAE,kBAAkB,EAAE;;AAE7E,+DAA+D;AAC/D;EACE,UAAU;AACZ;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;;EAEE,cAAc;EACd,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN;;2BAEyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,OAAO;EACP,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf;;;eAGa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd;;;eAGa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;;;AAIA,wDAAwD;AACxD;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;oBAEkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,OAAO;EACT;AACF;;AAEA,+DAA+D;;AAE/D,+DAA+D;AAC/D;;;EAGE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB;kEACgE;EAChE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,+DAA+D;AAC/D;EACE,oCAAoC;EACpC,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;EAC9C,2BAA2B;EAC3B,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iDAAiD;EACjD,cAAc;EACd,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf;;mBAEiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,+DAA+D;AAC/D;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,yCAAyC;EACzC,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC;;2BAEyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf;;;eAGa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;IACrB,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC;;oBAEkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;oBAEkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,OAAO;EACT;AACF","sourcesContent":["/* ── page wrapper ────────────────────────────────────────── */\n.op-page {\n  height: 100vh;\n  width: 100%;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 16px;\n  gap: 16px;\n  box-sizing: border-box;\n  font-family: \"Inter\", \"Segoe UI\", sans-serif;\n}\n\n@media (min-width: 1024px) {\n  .op-page {\n    padding: 20px;\n    gap: 20px;\n  }\n}\n\n/* ── header card (standalone) ────────────────────────────── */\n.op-header-card {\n  background: #ffffff;\n  border-radius: 24px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);\n  flex-shrink: 0;\n}\n\n/* ── old full card — neutralised ─────────────────────────── */\n.op-card {\n  display: contents;\n}\n\n/* ── header ──────────────────────────────────────────────── */\n.op-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n  flex-shrink: 0;\n}\n\n@media (min-width: 1024px) {\n  .op-header {\n    padding: 12px 32px;\n  }\n}\n\n.op-header-left-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.op-logo {\n  height: 28px;\n  width: auto;\n  object-fit: contain;\n}\n\n@media (min-width: 1024px) {\n  .op-logo {\n    height: 32px;\n  }\n}\n\n.op-step-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #bfdbfe;\n  color: #2a71ff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  padding: 4px 12px;\n  border-radius: 9999px;\n  background-color: #eff6ff;\n}\n\n/* ── back button ─────────────────────────────────────────── */\n.back-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: 1px solid #e2e8f0;\n  border-radius: 9999px;\n  background-color: #ffffff;\n  color: #64748b;\n  cursor: pointer;\n  transition:\n    background-color 0.2s ease,\n    color 0.2s ease;\n  flex-shrink: 0;\n}\n\n.back-btn:hover {\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n.back-icon {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* ── body ────────────────────────────────────────────────── */\n.op-body {\n  padding: 4px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #e2e8f0 transparent;\n}\n\n.op-body::-webkit-scrollbar { width: 4px; }\n.op-body::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 4px; }\n\n/* ── section panel — flat, no card chrome ────────────────── */\n.op-section {\n  padding: 0;\n}\n\n/* ── title/breadcrumb row — flat ─────────────────────────── */\n.op-setup-section {\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── opening cash — flat ─────────────────────────────────── */\n.op-cash-section {\n  padding: 0;\n}\n\n.op-section-tag {\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  color: #2a71ff;\n  margin: 0 0 6px 0;\n  text-transform: uppercase;\n}\n\n/* ── setup section header ────────────────────────────────── */\n.op-setup-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.op-title {\n  font-size: 1.5rem;\n  font-weight: 900;\n  color: #020617;\n  margin: 4px 0 0 0;\n  letter-spacing: -0.025em;\n}\n\n@media (min-width: 1024px) {\n  .op-title {\n    font-size: 2rem;\n  }\n}\n\n/* ── breadcrumbs ─────────────────────────────────────────── */\n.op-breadcrumbs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.op-crumb {\n  font-size: 13px;\n  font-weight: 700;\n  padding: 6px 16px;\n  border-radius: 9999px;\n  border: 1px solid;\n  /* default: blue (location) */\n  color: #2563eb;\n  background: rgba(239, 246, 255, 0.5);\n  border-color: #bfdbfe;\n}\n\n/* second crumb: green (terminal) */\n.op-crumb:nth-child(2) {\n  color: #059669;\n  background: rgba(236, 253, 245, 0.5);\n  border-color: #a7f3d0;\n}\n\n/* third / purple crumb (channel / retailType) */\n.op-crumb.purple,\n.op-crumb:nth-child(4) {\n  color: #7c3aed;\n  background: rgba(245, 243, 255, 0.5);\n  border-color: #ddd6fe;\n}\n\n.op-crumb.yellow,\n.op-crumb:nth-child(3) {\n  color: #92400e;\n  background: rgba(254, 243, 199, 0.5);\n  border-color: #fde68a;\n}\n\n/* ── checks section internals ────────────────────────────── */\n.op-checks-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  margin-bottom: 16px;\n}\n\n.op-clear-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: #94a3b8;\n  padding: 4px 0;\n  text-transform: uppercase;\n  transition: color 0.15s;\n}\n\n.op-clear-btn:hover {\n  color: #2a71ff;\n}\n\n/* ── check cards grid ────────────────────────────────────── */\n.op-checks-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n}\n\n/* ── single check card ───────────────────────────────────── */\n.op-check-card {\n  border-radius: 22px;\n  padding: 18px 18px 16px;\n  border: 1px solid #e8edf5;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  transition:\n    box-shadow 0.18s ease,\n    border-color 0.18s ease;\n}\n\n.op-check-card:hover {\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.07);\n}\n\n.op-check-card.ready {\n  border-color: #d1fae5;\n  background: #ffffff;\n}\n\n.op-check-card.attention {\n  border-color: #fde68a;\n  background: #ffffff;\n}\n\n.op-check-card.failed {\n  border-color: #fca5a5;\n  background: #ffffff;\n}\n\n/* ── card top row: icon + status badge ── */\n.op-check-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.op-check-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.op-check-icon.ready {\n  background: #ecfdf5;\n  color: #059669;\n}\n\n.op-check-icon.attention {\n  background: #fffbeb;\n  color: #d97706;\n}\n\n.op-check-icon.failed {\n  background: #fef2f2;\n  color: #ef4444;\n}\n\n.op-check-status {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  padding: 3px 10px;\n  border-radius: 9999px;\n}\n\n.op-check-status.ready {\n  color: #047857;\n  background: #ecfdf5;\n}\n\n.op-check-status.attention {\n  color: #b45309;\n  background: #fffbeb;\n}\n\n.op-check-status.failed {\n  color: #b91c1c;\n  background: #fef2f2;\n}\n\n/* ── card text ── */\n.op-check-name {\n  font-size: 14px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0 0 3px 0;\n  letter-spacing: -0.01em;\n}\n\n.op-check-desc {\n  font-size: 12px;\n  color: #94a3b8;\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* ── status info pill ── */\n.op-check-info {\n  background: #f8fafc;\n  border: 1px solid #f1f5f9;\n  border-radius: 10px;\n  padding: 9px 12px;\n  font-size: 11.5px;\n  font-weight: 500;\n  color: #64748b;\n  margin: 12px 0 0 0;\n  line-height: 1.45;\n  flex: 1;\n  min-height: 38px;\n}\n\n/* ── single action button at bottom ── */\n.op-check-card-actions {\n  margin-top: 14px;\n}\n\n/* \"Check\" state — outlined neutral */\n.op-check-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  height: 40px;\n  background: #ffffff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #374151;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    background 0.15s,\n    color 0.15s;\n}\n\n.op-check-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.op-check-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* Container for the retry and mark as ready buttons when checked */\n.op-checked-actions {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n/* Retry button — styled like .op-check-btn but square */\n.op-retry-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: #ffffff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 12px;\n  color: #374151;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition:\n    border-color 0.15s,\n    background 0.15s,\n    color 0.15s;\n}\n\n.op-retry-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.op-retry-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* \"Mark ready\" state — solid blue, same size */\n.op-mark-ready-btn {\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  height: 40px;\n  background: #2a71ff;\n  border: 1.5px solid transparent;\n  border-radius: 12px;\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.op-mark-ready-btn:hover:not(:disabled) {\n  background: #155eef;\n}\n\n.op-mark-ready-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n\n\n/* \"Confirmed\" state — green static badge (no pointer) */\n.op-check-confirmed {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  height: 40px;\n  background: #f0fdf4;\n  border: 1.5px solid #bbf7d0;\n  border-radius: 12px;\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #15803d;\n  cursor: default;\n}\n\n/* ── opening cash section ────────────────────────────────── */\n.op-cash-desc {\n  font-size: 13px;\n  color: #64748b;\n  margin: 6px 0 20px 0;\n}\n\n.op-cash-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.op-amount-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.op-rupee {\n  position: absolute;\n  left: 14px;\n  font-size: 14px;\n  font-weight: 900;\n  color: #94a3b8;\n  pointer-events: none;\n  line-height: 1;\n}\n\n.op-amount-input {\n  height: 48px;\n  width: 240px;\n  padding-left: 36px;\n  padding-right: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  font-size: 16px;\n  font-weight: 900;\n  color: #020617;\n  background: #ffffff;\n  outline: none;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\n.op-amount-input:focus {\n  border-color: #2a71ff;\n  box-shadow: 0 0 0 3px rgba(42, 113, 255, 0.1);\n}\n\n.op-amount-input::placeholder {\n  color: #cbd5e1;\n  font-weight: 400;\n}\n\n.op-amount-input::-webkit-outer-spin-button,\n.op-amount-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* ── action buttons ──────────────────────────────────────── */\n.op-cash-btns {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n  align-self: flex-end;\n}\n\n.op-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 48px;\n  padding: 0 32px;\n  border: 1px solid;\n  border-radius: 18px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    box-shadow 0.15s;\n  white-space: nowrap;\n}\n\n.op-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.op-btn.manager {\n  background: #4a72b5;\n  border-color: rgba(74, 114, 181, 0.3);\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(74, 114, 181, 0.2);\n}\n\n.op-btn.manager:hover:not(:disabled) {\n  background: #3a62a5;\n}\n\n.op-btn.pos-user {\n  background: #0f172a;\n  border-color: rgba(15, 23, 42, 0.2);\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.15);\n}\n\n.op-btn.pos-user:hover:not(:disabled) {\n  background: #1e293b;\n}\n\n/* ── bottom actions ──────────────────────────────────────── */\n.op-bottom-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-top: 4px;\n  flex-wrap: wrap;\n}\n\n.op-action-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: 38px;\n  padding: 0 18px;\n  border-radius: 30px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n  border: 1.5px solid;\n}\n\n.op-action-btn.location {\n  background: #f0f5ff;\n  border-color: #c5d4f0;\n  color: #4a72b5;\n}\n\n.op-action-btn.location:hover {\n  background: #e3ecff;\n}\n\n.op-action-btn.logout {\n  background: #fff5f5;\n  border-color: #fecaca;\n  color: #dc2626;\n}\n\n.op-action-btn.logout:hover {\n  background: #fee2e2;\n}\n\n/* ── responsive ──────────────────────────────────────────── */\n@media (max-width: 640px) {\n  .op-checks-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .op-cash-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .op-amount-input {\n    width: 100%;\n  }\n\n  .op-cash-btns {\n    justify-content: stretch;\n  }\n\n  .op-btn {\n    flex: 1;\n  }\n}\n\n/* duplicate op-card/op-body blocks removed — see top of file */\n\n/* ── global overflow fix ─────────────────────────────────── */\nhtml,\nbody,\n#root {\n  overflow-x: hidden;\n  max-width: 100%;\n}\n\n/* ── page wrapper ────────────────────────────────────────── */\n.system-health__page {\n  height: 100vh;\n  width: 100%;\n  overflow: hidden;\n  background: radial-gradient(circle at top left, rgba(42, 113, 255, 0.14), transparent 24%),\n    linear-gradient(180deg, #f6f9ff 0%, #eef4ff 45%, #f8fafc 100%);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 16px;\n  box-sizing: border-box;\n  font-family: \"Inter\", \"Segoe UI\", sans-serif;\n  color: #020617;\n}\n\n@media (min-width: 1024px) {\n  .system-health__page {\n    padding: 20px;\n  }\n}\n\n/* ── main card ───────────────────────────────────────────── */\n.system-health__card {\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 34px;\n  border: 1px solid rgba(255, 255, 255, 0.8);\n  width: 100%;\n  max-width: 1680px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 24px 90px rgba(15, 23, 42, 0.12);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  box-sizing: border-box;\n}\n\n/* ── header ──────────────────────────────────────────────── */\n.system-health__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n  flex-shrink: 0;\n  min-width: 0;\n}\n\n@media (min-width: 1024px) {\n  .system-health__header {\n    padding: 16px 32px;\n  }\n}\n\n.system-health__header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  min-width: 0;\n}\n\n.system-health__logo {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n@media (min-width: 1024px) {\n  .system-health__logo {\n    height: 44px;\n  }\n}\n\n.system-health__step-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #bfdbfe;\n  color: #2a71ff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  padding: 4px 12px;\n  border-radius: 9999px;\n  background-color: #eff6ff;\n  text-transform: uppercase;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* ── back button ─────────────────────────────────────────── */\n.system-health__back-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: 1px solid #e2e8f0;\n  border-radius: 9999px;\n  background-color: #ffffff;\n  color: #64748b;\n  cursor: pointer;\n  transition:\n    background-color 0.2s ease,\n    color 0.2s ease;\n  flex-shrink: 0;\n}\n\n.system-health__back-btn:hover {\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n.system-health__back-icon {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* ── body ────────────────────────────────────────────────── */\n.system-health__body {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  /* custom scrollbar */\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.system-health__body::-webkit-scrollbar {\n  width: 6px;\n}\n.system-health__body::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 9999px;\n}\n.system-health__body::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 9999px;\n}\n.system-health__body::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n@media (min-width: 1024px) {\n  .system-health__body {\n    padding: 40px;\n  }\n}\n\n/* ── inner content max-width wrapper ─────────────────────── */\n.system-health__body > * {\n  max-width: 1200px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  box-sizing: border-box;\n}\n\n/* ── section panel ───────────────────────────────────────── */\n.system-health__section {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 28px;\n  padding: 20px 24px;\n  box-sizing: border-box;\n  min-width: 0;\n}\n\n@media (min-width: 1024px) {\n  .system-health__section {\n    padding: 24px 32px;\n  }\n}\n\n.system-health__section-tag {\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  color: #2a71ff;\n  margin: 0 0 6px 0;\n  text-transform: uppercase;\n}\n\n/* ── setup section header ────────────────────────────────── */\n.system-health__setup-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  min-width: 0;\n}\n\n@media (max-width: 640px) {\n  .system-health__setup-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.system-health__title {\n  font-size: 1.5rem;\n  font-weight: 900;\n  color: #020617;\n  margin: 4px 0 0 0;\n  letter-spacing: -0.025em;\n}\n\n@media (min-width: 1024px) {\n  .system-health__title {\n    font-size: 2rem;\n  }\n}\n\n/* ── breadcrumbs ─────────────────────────────────────────── */\n.system-health__breadcrumbs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.system-health__crumb {\n  font-size: 13px;\n  font-weight: 700;\n  padding: 6px 16px;\n  border-radius: 9999px;\n  border: 1px solid;\n  color: #2563eb;\n  background: rgba(239, 246, 255, 0.5);\n  border-color: #bfdbfe;\n  white-space: nowrap;\n}\n\n.system-health__crumb:nth-child(2) {\n  color: #059669;\n  background: rgba(236, 253, 245, 0.5);\n  border-color: #a7f3d0;\n}\n\n.system-health__crumb--purple,\n.system-health__crumb:nth-child(3) {\n  color: #7c3aed;\n  background: rgba(245, 243, 255, 0.5);\n  border-color: #ddd6fe;\n}\n\n/* ── check cards grid ────────────────────────────────────── */\n.system-health__checks-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  min-width: 0;\n}\n\n@media (max-width: 1023px) {\n  .system-health__checks-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 640px) {\n  .system-health__checks-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── single check card ───────────────────────────────────── */\n.system-health__check-card {\n  border-radius: 26px;\n  padding: 20px;\n  border: 1px solid #e8edf5;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  transition:\n    box-shadow 0.18s ease,\n    border-color 0.18s ease;\n  box-sizing: border-box;\n  min-width: 0;\n}\n\n.system-health__check-card:hover {\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.07);\n}\n\n.system-health__check-card--ready {\n  border-color: #d1fae5;\n  background: #ffffff;\n}\n\n.system-health__check-card--attention {\n  border-color: #fde68a;\n  background: #ffffff;\n}\n\n/* ── card top row: icon + status badge ── */\n.system-health__check-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 0;\n}\n\n.system-health__check-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.system-health__check-icon--ready {\n  background: #ecfdf5;\n  color: #059669;\n}\n\n.system-health__check-icon--attention {\n  background: #fffbeb;\n  color: #d97706;\n}\n\n.system-health__check-status {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  padding: 4px 12px;\n  border-radius: 9999px;\n}\n\n.system-health__check-status--ready {\n  color: #047857;\n  background: #ecfdf5;\n}\n\n.system-health__check-status--attention {\n  color: #b45309;\n  background: #fffbeb;\n}\n\n/* ── card text ── */\n.system-health__check-name {\n  font-size: 18px;\n  font-weight: 900;\n  color: #0f172a;\n  margin: 20px 0 4px 0;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.system-health__check-desc {\n  font-size: 13px;\n  color: #94a3b8;\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* ── status info pill ── */\n.system-health__check-info {\n  background: #f8fafc;\n  border: 1px solid #f1f5f9;\n  border-radius: 16px;\n  padding: 12px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #475569;\n  margin: 16px 0 0 0;\n  line-height: 1.45;\n}\n\n/* ── single action button at bottom ── */\n.system-health__check-actions {\n  margin-top: 20px;\n}\n\n/* \"Check\" state — outlined neutral */\n.system-health__check-btn {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 44px;\n  background: #ffffff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 16px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #374151;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    background 0.15s,\n    color 0.15s;\n}\n\n.system-health__check-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.system-health__check-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* \"Mark ready\" state — solid blue */\n.system-health__mark-ready-btn {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 44px;\n  background: #2a71ff;\n  border: 1.5px solid transparent;\n  border-radius: 16px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.system-health__mark-ready-btn:hover {\n  background: #155eef;\n}\n\n/* \"Confirmed\" state — green static badge */\n.system-health__check-confirmed {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 44px;\n  background: #f0fdf4;\n  border: 1.5px solid #bbf7d0;\n  border-radius: 16px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #15803d;\n  cursor: default;\n}\n\n/* ── opening cash section ────────────────────────────────── */\n.system-health__cash-desc {\n  font-size: 13px;\n  color: #64748b;\n  margin: 6px 0 20px 0;\n  line-height: 1.5;\n}\n\n.system-health__cash-row {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n}\n\n@media (min-width: 1024px) {\n  .system-health__cash-row {\n    flex-direction: row;\n    align-items: flex-end;\n    justify-content: space-between;\n  }\n}\n\n.system-health__cash-left {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  width: 100%;\n  max-width: 400px;\n  min-width: 0;\n}\n\n.system-health__amount-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-top: 16px;\n}\n\n.system-health__rupee-symbol {\n  position: absolute;\n  left: 14px;\n  font-size: 14px;\n  font-weight: 900;\n  color: #94a3b8;\n  pointer-events: none;\n  line-height: 1;\n}\n\n.system-health__amount-input {\n  height: 48px;\n  width: 100%;\n  max-width: 240px;\n  padding-left: 36px;\n  padding-right: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  font-size: 16px;\n  font-weight: 900;\n  color: #020617;\n  background: #ffffff;\n  outline: none;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n  box-sizing: border-box;\n}\n\n.system-health__amount-input:focus {\n  border-color: #2a71ff;\n  box-shadow: 0 0 0 3px rgba(42, 113, 255, 0.1);\n}\n\n.system-health__amount-input::placeholder {\n  color: #cbd5e1;\n  font-weight: 400;\n}\n\n.system-health__amount-input::-webkit-outer-spin-button,\n.system-health__amount-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* ── action buttons ──────────────────────────────────────── */\n.system-health__cash-btns {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.system-health__cta-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 48px;\n  padding: 0 32px;\n  border: 1px solid;\n  border-radius: 18px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    box-shadow 0.15s;\n  white-space: nowrap;\n}\n\n.system-health__cta-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.system-health__cta-btn--manager {\n  background: #4a72b5;\n  border-color: rgba(74, 114, 181, 0.3);\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(74, 114, 181, 0.2);\n}\n\n.system-health__cta-btn--manager:hover:not(:disabled) {\n  background: #3a62a5;\n}\n\n.system-health__cta-btn--pos-user {\n  background: #0f172a;\n  border-color: rgba(15, 23, 42, 0.2);\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.15);\n}\n\n.system-health__cta-btn--pos-user:hover:not(:disabled) {\n  background: #1e293b;\n}\n\n/* ── responsive cash row ─────────────────────────────────── */\n@media (max-width: 640px) {\n  .system-health__cash-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .system-health__cash-left {\n    max-width: 100%;\n  }\n\n  .system-health__amount-input {\n    max-width: 100%;\n  }\n\n  .system-health__cash-btns {\n    justify-content: stretch;\n  }\n\n  .system-health__cta-btn {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
